
<template>
  <div id="loginbackground">
    <div class="loginCont">
      <div id="loginText">
        <p>猎户语音OS 真开放</p>
        <ul>
          <li>
            <span class="logSpan"></span>
            <span>全链路自研</span>
          </li>
          <li>
            <span class="logSpan"></span>
            <span>行业一流人机交互体验</span>
          </li>
          <li>
            <span class="logSpan"></span>
            <span>数据，商业，内容，技能全开放</span>
          </li>
          <li>
            <span class="logSpan"></span>
            <span>简单高效地接入AI能力</span>
          </li>
        </ul>
      </div>
      <div class="login">
        <p>用户登录</p>
        <div class="main_container">
          <el-form :rules="loginInspect" :model="userInfo" ref="userInfo">
            <el-form-item prop="user_phone">
              <el-input placeholder="请输入您的手机号" v-model.trim="userInfo.user_phone"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" placeholder="请输入您的密码" v-model="userInfo.password" @keyup.enter.native="Login"></el-input>
            </el-form-item>
          </el-form>
          <!--<el-checkbox label="自动登录" name="type" v-model="userInfo.remember"></el-checkbox>-->

        </div>
        <el-button type="primary" round @click="Login" :disabled="!userInfo.user_phone || !userInfo.password">登录</el-button>
        <div style="text-align: center;margin-top:10px;">
          <router-link to="/register">立即注册</router-link>
          <span style="display: inline-block;margin:0 20px;">|</span>
          <router-link to="/forgetPassword"  class="forget">忘记密码</router-link>
        </div>

      </div>
    </div>

  </div>

</template>
<script>
  import qs from 'qs'
  import {login, setHeaders} from '@/api'
    export default {
      created(){
      },
      data () {
        let validate_phone = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入您的手机号'));
          } else {
            if (this.userInfo.user_phone !== '') {
              let reg = /^1\d{10}$/
                let reg_tw = /^09\d{8}$/
              if(!reg.test(this.userInfo.user_phone))
              {
              if (!reg_tw.test(this.userInfo.user_phone)) {
                  callback(new Error('请输入正确的手机号'))

              } else {
                  callback()
              }
              }
            }
            callback();
          }
        };
        let validate_pass = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入您的密码'))
          } else if (value.length < 6) {
            callback(new Error('密码不能小于六位'))
          } else if (value.length > 16) {
            callback(new Error('密码不能大于十六位'))
          } else {
            if (this.userInfo.password !== '') {
              let reg = /\s+/g
              if(reg.test(this.userInfo.password))
              {
                callback(new Error('请输入正确的密码，不支持空格'))
              }
            }
            callback();
          }
        };
        return {
          userInfo: {
            user_phone: '',
            password: '',
//            remember: 0
          },
          loginInspect: {
            user_phone: [
//              { required: true, message: '请输入您的手机号', trigger: ['blur', 'change']},
              {validator: validate_phone, required: true, trigger: 'blur'},
            ],
          password: [
            {validator: validate_pass, required: true, trigger: 'blur'},
          ]
          }
        }
      },
      methods: {
        setCookie (name, value, day) {
            if (document.location.host == 'opentw.ainirobot.com') {
                name = name + '_tw'
            }
          let Days = day
          let exp = new Date()
          exp.setTime(exp.getTime() + Days*24*60*60*1000)
          if (document.location.host == 'open.ainirobot.com' || document.location.host == 'opentw.ainirobot.com') {
            document.cookie = name + "="+ value + ";expires=" + exp.toGMTString() +";domain=.ainirobot.com"
          } else {
            document.cookie = name + "="+ value + ";expires=" + exp.toGMTString()
          }
        },
         async Login () {
          let res =await login(qs.stringify(this.userInfo))
           if (res.data.code == 200) {
//            if (this.userInfo.remember) {
              this.setCookie('token', res.data.data.token, 7)
              this.setCookie('userTel', this.userInfo.user_phone, 7)
              setHeaders()
//            } else {
//              this.setCookie('token', res.data.data.token, 1)
//              this.setCookie('userTel', this.userInfo.user_phone, 1)
//              setHeaders()
//            }
             let where = this.$store.state.where;
            if(where == 'product'){
              window.location.href = '/hardhome'
            }else if(where == 'skill'){
              window.location.href = '/homePage'
            }else{
                if (window.location.host.includes('opentw.ainirobot.com')) {
                    window.location.href = 'https://voiceostw.ainirobot.com'
                } else {
                    window.location.href = 'https://voiceos.ainirobot.com'
                }
            }//判断用户之前从什么页面登录的，再跳回那个页面

           } else {
            if (res.data.code == 400) {
              this.$message({message: '登录失败', type: 'error'})
              return
            }
             if (res.data.errors == {}) {
               this.$message({message: '登录失败', type: 'error'})
             } else {
               this.$message({message: res.data.errors.data, type: 'error'})
             }
           }
        }
      },
      mounted() {
      }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
  #loginbackground{
    width: 100%;
    height: 100%;
    background:url('../../../static/images/loginBackground/login-bg.jpg');
    background-size:cover;
    background-repeat:no-repeat;
  }
  .loginCont{
    width: 937px;
    height: 380px;
    position: absolute;
    top: 50%;
    left:50%;
    transform: translate(-50%, -50%);
    #loginText{
      color:#fff;
      width: 279px;
      float:left;
      margin-top:80px;
      p{
        font-size:28px;
        line-height: 60px;
      }
      ul>li{
        list-style: none;
        line-height: 30px;
        span{
        font-size: 14px;
        &.logSpan{
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background:#077eec;
          margin-right:10px;
          vertical-align: middle;
        }
      }}


    }
    .login{
      width: 370px;
      height: 380px;
      background:#fff;
      text-align: center;
      float:right;
      /*position: absolute;*/
      /*top: 45%;*/
      /*left: 75%;*/
      //margin: -140px 0 0 -166px;
      .el-form-item .el-form-item__error{
        left:10px;
      }
      p{
        height:64px;
        line-height:64px;
        border-bottom:1px solid #f5f5f5;
        font-size:18px;
        /*font-weight: 600;*/
        color:#22608c;
        text-align: center;
        /*padding-left:90px;*/
      }

      .main_container{
        text-align: center;
        padding: 40px 50px 0;
        color:#959595;
        .el-input__inner{
          width: 260px;
          border-radius: 20px;
        }
        .el-checkbox{
          margin:0 55px 0 50px;
        }
        a{
          font-size:14px;
          color:#0091ed;
        }
        .forget{
          margin-right:-190px;
        }
      }
      .el-button{
        width: 260px;
        font-size: 16px;
        margin:30px auto 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue